export const MARKET_ROUTE = '/market';
/** Matches the Documents grid: 5 columns × 5 rows. */
export const PAGE_SIZE = 25;
